// extracted by mini-css-extract-plugin
export var button = "FigmaToCode-module--button--cmn5v";
export var bxTextTruncateEnd = "FigmaToCode-module--bx--text-truncate--end--qDsfb";
export var bxTextTruncateFront = "FigmaToCode-module--bx--text-truncate--front--kAoML";
export var container = "FigmaToCode-module--container--ru8yR";
export var dot = "FigmaToCode-module--dot--S4hGv";
export var inlineContainer = "FigmaToCode-module--inlineContainer--JKPdh";
export var newFeatures = "FigmaToCode-module--newFeatures--+pnM+";
export var wrapper = "FigmaToCode-module--wrapper--tN7VY";